import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import mainImg from '../NotReady.png';
import '../NotReady.scss';

class NotReadyScene extends React.Component {

    public render() {
        return <React.Fragment>
            <PageContent pageName="[ERROR] Not Ready">
                <PageBody>
                    <div className="notready-content">
                        <h1>Hold On, This Isn't Ready</h1>
                        <img src={mainImg} />
                        <h3>This page is still under production.  Check back later! </h3>
                    </div>
                </PageBody>
            </PageContent>
        </React.Fragment>
    }
}

export { NotReadyScene }